import React from 'react';
import { BlackboardLogo } from './BlackboardLogo';

export const Logo = (props: React.HTMLAttributes<SVGElement>) => (
  <BlackboardLogo titleId="blackboard-logo" {...props} />
);

export default Logo;
